module.exports = __webpack_public_path__ + "img/gera4.jpg";